<template>
  <div class="bd-front-user">
    <InstitucionalHeader/>
    <div class="main-content">
      <router-view></router-view>
      <InstitucionalParceiros v-if="$route.name !== 'Login'"/>
    </div><!-- fim main content-->
    <InstitucionalFooter/>
  </div>
</template>

<script>
import InstitucionalHeader from '@/components/institucional/InstitucionalHeader'
import InstitucionalParceiros from '@/components/institucional/InstitucionalParceiros'
import InstitucionalFooter from '@/components/institucional/InstitucionalFooter'
export default {
  name: 'InstitucionalContent',
  components: { InstitucionalHeader, InstitucionalParceiros, InstitucionalFooter }
}
</script>
